import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstants } from 'src/app/app.constant';
import { TableColumn } from 'src/app/interfaces/TableColumn';
import { CommonService } from 'src/app/service/common.service';
import { DrugBrandService } from 'src/app/service/drug-brand.service';
import { MenuService } from 'src/app/service/menu.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-drug-brand',
  templateUrl: './drug-brand.component.html',
  styleUrls: ['./drug-brand.component.scss'],
})
export class DrugBrandComponent implements OnInit {
  public displayedColumns: TableColumn[] = [
    {
      name: 'ID',
      dataKey: 'id',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['id']}`,
    },
    {
      name: 'Drug Brand Name',
      dataKey: 'brand_name',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['brand_name']}`,
    },
    {
      name: 'Generic',
      dataKey: 'generic_name',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['generic_name']}`,
    },
    {
      name: 'Snomed Ids',
      dataKey: 'snomed_id',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['snomed_id']}`,
    },
  ];

  public title = 'Drug Brand';
  public totalRows = 0;
  public pageSize = 10;
  public currentPage = 0;
  public filterValue = '';
  public sortField = '';
  public sortOrder = '';
  public pageSizeOptions: number[] = AppConstants.pageSizeOptions;
  public loading: boolean = false;
  public data: any;
  public isApproved: number = 1;
  public editLink = 'dictionary-management/drug-brand/edit/';
  public currentMenuPermission: any;

  constructor(
    private drugBrandService: DrugBrandService,
    private commonService: CommonService,
    protected router: Router,
    private route: ActivatedRoute,
    private menuService: MenuService
  ) {}

  ngOnInit(): void {
    this.menuService.currentMenu.subscribe(currentMenu => {
      this.currentMenuPermission = currentMenu;
    });
    this.route.queryParams.subscribe((queryParams: any) => {
      this.isApproved =
        this.router.url.indexOf('curation-pending') >= 0 ? 0 : 1;
      this.getAll();
    });
  }

  /**
   * This function is user to get all User Listing
   * @author Dhaval Bera
   */
  getAll() {
    this.loading = true;
    this.drugBrandService
      .getRecordByFilter(
        this.currentPage + 1,
        this.sortField,
        this.sortOrder,
        this.filterValue,
        this.pageSize,
        this.isApproved
      )
      .subscribe({
        next: (result: any) => {
          this.loading = false;
          this.data = result.data.data;
          this.totalRows = result.data.total;
        },
        error: (e) => {
          this.loading = false;
          console.log('drug brand Listing err :: ', e);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  editAction(event: any) {
    this.router.navigate([this.editLink + event.id]);
  }
  /**
   * call Create Organ site api
   * @returns null
   */
  deleteDrugGeneric(event: any) {
    Swal.fire({
      title: 'Delete?',
      html: 'Are you sure want to delete the drug brand?',
      imageUrl: '../../../../../assets/images/delete.svg',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'btn mat-secoundary',
        cancelButton: 'btn mat-warn ml-1',
      },
    }).then((result) => {
      if (result.value) {
        this.drugBrandService.delete(event.id).subscribe({
          next: (result: any) => {
            if (result.status === AppConstants.serverSuccessStatus) {
              this.commonService.showSuccessToast(
                result.message
              );
              this.getAll();
            } else {
              this.commonService.showErrorToast(
                "Drug brand can't be deleted. Please try again later."
              );
            }
          },
          error: (e: any) => {
            this.commonService.showErrorToast('Drug brand not found');
          },
        });
      }
      if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  searchFilter(filterValue: any) {
    this.filterValue = filterValue;
    this.currentPage = 0;
    this.getAll();
  }
  SortFilter(sortState: any) {
    if (sortState.active !== '' && sortState.direction !== '') {
      this.sortField = sortState.active;
      this.sortOrder = sortState.direction;
      this.getAll();
    }
  }
  pageChanged(event: any) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getAll();
  }
}
